import { render, staticRenderFns } from "./Aktuelles.vue?vue&type=template&id=af0dc6f6&scoped=true"
import script from "./Aktuelles.vue?vue&type=script&lang=js"
export * from "./Aktuelles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0dc6f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af0dc6f6')) {
      api.createRecord('af0dc6f6', component.options)
    } else {
      api.reload('af0dc6f6', component.options)
    }
    module.hot.accept("./Aktuelles.vue?vue&type=template&id=af0dc6f6&scoped=true", function () {
      api.rerender('af0dc6f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/news/Aktuelles.vue"
export default component.exports